// extracted by mini-css-extract-plugin
export var root = "M_xw";
export var wrapper = "M_qk";
export var image = "M_xx d_w d_y d_W";
export var imageWithHeight = "M_xy";
export var crop = "M_xz";
export var round = "M_xB";
export var fixedHeight = "M_xC";